import { useQuery } from '@tanstack/react-query';
import { getSubActivityList } from 'services/reactQueryservices';

const useGetSubActivityList = (projectType: string) => {
    const { data, isFetching, isFetched, isError, error } = useQuery({
        queryKey: ['subActivityList', projectType],
        queryFn: () => getSubActivityList(projectType),
        refetchOnWindowFocus: false,
        enabled: !!projectType // Only fetch when projectType is provided
    });

    return {
        data,
        isFetching,
        isFetched,
        isError,
        error
    };
};

export default useGetSubActivityList;
